<template>
  <div :id="`${machineTipKey}`" class="machine-tip">
    <!-- 机器 -->
    <div class="machine" >
      <div class="machine-box">
        <!-- 机器名称 -->
        <div class="machine-title">
          <div class="name">
            {{ machineData.machineName }}
            <div class="abnormal-icon"  v-show="isEdit"></div>
          </div>
          <div class="check"  v-show="!isEdit">
            查看详情
            <span></span>
          </div>
        </div>
        <!-- 机器数值 -->
        <div class="machine-cont">
          <!-- 信息行 -->
          <div
            class="info-line"
            v-for="v in machineInfo"
            :key="v.key"
          >
            <div class="infoName">{{ v.filedName }}</div>
            <div class="infoNum">{{ v.value + v.filedUnit }}</div>
          </div>
        </div>
      </div>
      <div class="machine-edit" @click="editFn(machineTipKey)" v-show="isEdit">
        <div class="edit-bg"></div>
        <div>编辑</div>
      </div>
    </div>
    <!-- 多选列表 -->
    <machine-list-tip
      :key="machineData.name"
      :machineData="machineData"
      :machineTipKey="machineTipKey"
      @child-closeFn="closeFn"
      v-show="machine === machineTipKey && isEdit"
    ></machine-list-tip>
  </div>
</template>
<script>
import machineListTip from "./machineListTip.vue";
export default {
  props: ["machineList", "machineKey", "isHomeEdit"],
  components: {
    machineListTip,
  },
  data() {
    return {
      // 所有机器数据
      machineData: {
        name: "",
        list: [],
      },
      // 机器的key
      machineTipKey: "",
      // 显示数据
      machineInfo: [],
      machine: null,
      // 是否显示编辑按钮
      isEdit: false,
    };
  },
  mounted() {
    this.machineTipKey = this.machineKey;
    this.machineData = this.machineList;
    window.tipGetData = this.tipGetData;
  },
  methods: {
    // 编辑按钮
    editFn(i) {
      if (this.machine == null) {
        this.machine = i;
      } else {
        this.machine = null;
      }
    },
    // 子组件关闭按钮
    closeFn() {
      this.machine = null;
    },
    // 查看详情
    machineCheckFn() {
      console.log("查看详情");
    },
    tipGetData(){
      // this.machineData = this.machineList;
      // this.machineInfo = this.machineData.list.filter((v) => v.type === 1);
      // console.log(this.machineData,"22222");
    }
  },

  watch: {
    isHomeEdit(n) {
      this.isEdit = n;
    },
    machineList(n) {
      this.machineInfo = [];
      this.machineData = n;
      this.machineInfo = this.machineData.filedVoList.filter((v) => v.isChoose === 1);
    },
  },
};
</script>
<style lang="less" scoped>
.machine-tip {
  display: flex;

  .machine {
    width: 276px;
    height: 100%;
    display: flex;
    // transform: scale(0.8);

    .machine-box {
      width: calc(100% - 19px);
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(113, 118, 136, 0.5) 0%,
        rgba(0, 0, 0, 0.1) 100%
      );
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
      border: 1px solid;
      border-image: linear-gradient(
          180deg,
          rgba(151, 151, 151, 0),
          rgba(200, 200, 200, 1)
        )
        1 1;

      // 机器名称
      .machine-title {
        width: 256.8px;
        height: 35.2px;
        padding: 0 8px 0 10px;
        margin: -1px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        background: url("./images/machineTip-bg.png") no-repeat 0 0;
        background-size: 100% 100%;

        .name {
          display: flex;
          align-items: center;

          .abnormal-icon {
            width: 15px;
            height: 15px;
            background: url("./images/abnormal.png") no-repeat 0 0;
            background-size: 100% 100%;
            margin-left: 6px;
            // cursor: pointer;
          }
        }

        .check {
          height: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          span {
            width: 24px;
            height: 14px;
            margin-top: 3px;
            margin-left: 8px;
            background: url("./images/right-arrow.png") no-repeat 0 center;
            background-size: 100% 100%;
          }
        }
      }
      // 机器数值
      .machine-cont {
        width: 100%;
        height: calc(100% - 35px);
        padding: 10px 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-line {
          display: flex;
          justify-content: space-between;

          .infoName {
            width: 120px;
            height: 27.2px;
            background: linear-gradient(
              90deg,
              rgba(113, 118, 136, 0.3) 0%,
              rgba(113, 118, 136, 0.2) 100%
            );
            border: 1px solid;
            border-image: linear-gradient(
                270deg,
                rgba(151, 151, 151, 0.2),
                rgba(200, 200, 200, 1)
              )
              1 1;
            backdrop-filter: blur(3px);
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
            line-height: 27.2px;
          }

          .infoNum {
            width: 130px;
            height: 27.2px;
            border: 1px solid;
            padding-left: 16px;
            border-image: linear-gradient(
                96deg,
                rgba(200, 200, 200, 1),
                rgba(151, 151, 151, 0)
              )
              1 1;
            font-size: 14px;
            font-weight: 500;
            color: #ff7700;
            line-height: 27.2px;
            background: linear-gradient(180deg, #ffffff 0%, #00dbff 100%);
            background-clip: text;
            // -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }

    .machine-edit {
      width: 19px;
      height: 80px;
      padding-top: 9.6px;
      background: url("./images/machine-edit.png") no-repeat 0 0;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .edit-bg {
        width: 11.2px;
        height: 11.2px;
        background: url("./images/edit.png") no-repeat center center;
        background-size: 100% 100%s;
      }

      div {
        width: 16px;
        height: 36px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        white-space: pre-wrap;
      }
    }
  }

  .machineListTip {
    margin-left: 6px;
    z-index: 1;
  }
}
</style>